import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-message-copied',
  templateUrl: './message-copied.component.html',
  styleUrls: ['./message-copied.component.css']
})
export class MessageCopiedComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
